/*
 * Newsletter signup -> Klaviyo (client-side subscription).
 *
 * Unifies the plain "Subscribe to our emails" forms with the Craft Finder flow so that
 * both land in the SAME Klaviyo list. Unlike the Craft Finder, this signup carries NO
 * craft_type / quiz properties, so plain subscribers stay untagged (only differentiated
 * by custom_source), while diagnosis leads remain distinguishable by their profile props.
 *
 * Uses the public company ID only (safe to expose). Consent handling follows the Klaviyo
 * list configuration (single/double opt-in). No Shopify customer is created on this path.
 */
(function () {
  'use strict';

  var KLAVIYO_ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  function bind(form) {
    // スニペットがscriptを複数回読み込んでも二重購読しないようガード
    if (form.dataset.klaviyoBound) { return; }
    form.dataset.klaviyoBound = '1';

    var cfg = {};
    var cfgEl = form.querySelector('[data-klaviyo-config]');
    if (cfgEl) { try { cfg = JSON.parse(cfgEl.textContent) || {}; } catch (e) {} }

    var emailInput = form.querySelector('input[type="email"]');
    var wrapper = form.querySelector('.newsletter-form__field-wrapper');
    var consent = form.querySelector('.newsletter-form__consent');
    var errorBox = form.querySelector('[data-klaviyo-error]');
    var errorText = form.querySelector('[data-klaviyo-error-text]');
    var successBox = form.querySelector('[data-klaviyo-success]');

    function showError(msg) {
      if (errorText) { errorText.textContent = msg; }
      if (errorBox) { errorBox.hidden = false; }
    }
    function hideError() { if (errorBox) { errorBox.hidden = true; } }

    function onSuccess() {
      if (wrapper) { wrapper.hidden = true; }
      if (consent) { consent.hidden = true; }
      if (successBox) {
        successBox.hidden = false;
        if (typeof successBox.focus === 'function') { successBox.focus(); }
      }
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (emailInput && emailInput.value || '').trim();
      if (!EMAIL_RE.test(email)) {
        showError('Please enter a valid email address.');
        if (emailInput) { emailInput.focus(); }
        return;
      }
      hideError();

      // 設定が欠けている場合は成功を装わず、明示的に失敗を伝える
      if (!cfg.companyId || !cfg.listId) {
        showError('Sign-up is temporarily unavailable. Please try again later.');
        return;
      }

      var body = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: cfg.source || 'Newsletter',
            profile: { data: { type: 'profile', attributes: { email: email } } }
          },
          relationships: { list: { data: { type: 'list', id: cfg.listId } } }
        }
      };

      fetch(KLAVIYO_ENDPOINT + '?company_id=' + encodeURIComponent(cfg.companyId), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify(body)
      }).then(function (res) {
        if (res.ok) { onSuccess(); }
        else { showError('Something went wrong. Please try again.'); }
      }).catch(function () {
        showError('Something went wrong. Please try again.');
      });
    });
  }

  ready(function () {
    var forms = document.querySelectorAll('form[data-klaviyo-signup]');
    for (var i = 0; i < forms.length; i++) { bind(forms[i]); }
  });
})();
